import { useAppSelector } from 'shared/lib';

import { whiteLabelAffIdSelector } from 'entities/whiteLabels';

import { DefaultDescription, FormStepDescriptionConfig } from './FormStepDescription.config';

export const useFormStepDescriptionComponent = () => {
  const partnerId = useAppSelector(whiteLabelAffIdSelector);

  if (!partnerId) {
    return DefaultDescription;
  }

  const WlStepTitle = FormStepDescriptionConfig[partnerId] || null;

  if (!WlStepTitle) {
    return DefaultDescription;
  }

  return WlStepTitle;
};
